import * as React from "react";
import { Helmet } from "react-helmet";
import "./contact.css";
import "../../page-layout.css";
import { Snackbar, Slide, IconButton } from "@material-ui/core";
import { useState } from "react";
import { AtSign, Mail, MapPin, Phone, X } from "lucide-react";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [services, setServices] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);

  const submitForm = async (e) => {
    e.preventDefault();

    const emailTemplate = `
      <html><body>
        <div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;padding:20px;background:#f5f5f5;">
          <p><b>Ime:</b> ${name}</p>
          <p><b>Email:</b> ${email}</p>
          <p><b>Usluga:</b> ${services}</p>
          <p><b>Poruka:</b> ${message}</p>
        </div>
      </body></html>
    `;

    try {
      await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message: emailTemplate }),
      });
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setOpen(true);
        document.getElementById("contact-form").reset();
      }, 3000);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  return (
    <div className="page-wrap">
      <Helmet>
        <title>Kontakt | Mihailo Živanović</title>
      </Helmet>

      <div className="page-hero">
        <div className="page-hero-inner">
          <div className="page-hero-eyebrow">Stupi u kontakt</div>
          <h1 className="page-hero-title">KONTAKT</h1>
          <p className="page-hero-desc">
            Pošalji poruku, zakaži trening ili pozovi direktno. Tu sam da odgovorim
            na sva tvoja pitanja.
          </p>
        </div>
      </div>

      <div className="contact-body">
        <div className="contact-inner">

          {/* FORM */}
          <div className="contact-form-col">
            <div className="contact-form-label">Pošalji poruku</div>
            <form id="contact-form" onSubmit={submitForm} className="contact-form">
              <div className="form-group">
                <label>Ime i Prezime <span className="required">*</span></label>
                <input
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Vaše ime i prezime"
                  required
                />
              </div>

              <div className="form-group">
                <label>Email <span className="required">*</span></label>
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Vaša email adresa"
                  required
                />
              </div>

              <div className="form-group">
                <label>Usluga <span className="required">*</span></label>
                <select onChange={(e) => setServices(e.target.value)} required>
                  <option value="">Izaberite uslugu</option>
                  <option value="Uživo trening">Uživo trening</option>
                  <option value="Online trening">Online trening</option>
                  <option value="Plan ishrane">Plan ishrane</option>
                </select>
              </div>

              <div className="form-group">
                <label>Poruka <span className="required">*</span></label>
                <textarea
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Vaša poruka..."
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="contact-submit"
              >
                {loading ? "Slanje..." : "Pošalji poruku"}
                {loading && <span className="spinner" />}
              </button>
            </form>
          </div>

          {/* INFO */}
          <div className="contact-info-col">
            <div className="contact-form-label">Kontakt informacije</div>

            <div className="contact-info-cards">
              <div className="contact-info-card">
                <span className="contact-info-icon">
                  <Phone size={18} strokeWidth={2.2} />
                </span>
                <div>
                  <span className="contact-info-card-label">Telefon</span>
                  <a href="tel:+381600737363">+381 60 073 7363</a>
                </div>
              </div>

              <div className="contact-info-card">
                <span className="contact-info-icon">
                  <Mail size={18} strokeWidth={2.2} />
                </span>
                <div>
                  <span className="contact-info-card-label">Email</span>
                  <a href="mailto:info@mihailo-fitness.rs">info@mihailo-fitness.rs</a>
                </div>
              </div>

              <div className="contact-info-card">
                <span className="contact-info-icon">
                  <MapPin size={18} strokeWidth={2.2} />
                </span>
                <div>
                  <span className="contact-info-card-label">Lokacija</span>
                  <a
                    href="https://maps.app.goo.gl/3GKRGbX24zaTXY8g9"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Planet Gym &amp; Fitness, Beograd
                  </a>
                </div>
              </div>

              <div className="contact-info-card">
                <span className="contact-info-icon">
                  <AtSign size={18} strokeWidth={2.2} />
                </span>
                <div>
                  <span className="contact-info-card-label">Instagram</span>
                  <a
                    href="https://www.instagram.com/mihailo_zivanovic/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @mihailo_zivanovic
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-map-wrap">
              <iframe
                title="Lokacija"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.1762266427077!2d20.507385111944266!3d44.81797437620261!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a7af44cea18ff%3A0x764c4be0e6b85a71!2sPlanet%20Gym%20%26%20Fitness!5e0!3m2!1sen!2srs!4v1738781154463!5m2!1sen!2srs"
                allowFullScreen=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        TransitionComponent={Slide}
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        message="Poruka je uspešno poslata. Hvala!"
        action={
          <IconButton onClick={() => setOpen(false)} aria-label="Zatvori obaveštenje">
            <X color="#fff" size={20} strokeWidth={2.2} />
          </IconButton>
        }
      />
    </div>
  );
}

export default Contact;
